module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead12-f8d4752e455bd04cbe6e34d680a3b3cb.jpg";